{
	"ariaNextAIStyle": "Next AI Style",
	"ariaPreviousAIStyle": "Previous AI Style"
}
